export default __webpack_public_path__ + "static/media/home.5225bb09.svg";